import classNames from "classnames";
import React, { PropTypes } from "react";
import { ButtonToolbar } from "react-bootstrap";
import { FormattedHTMLMessage, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { CheckboxButton, EditButton } from "../../../../common";
import { DataTable } from "../../../../common/DataTable";
import { BasicClientCoveragesFields } from "./";

import * as dataActions from "../../../../../utils/data/dataActions";
import { CLIENT_COVERAGES } from "../../../../../utils/data/models";
import guaranteeTypes from "../../../admin/guarantees/enums/guaranteeTypes";
import clientCoverageTaxTypes from "./enums/clientCoverageTaxTypes";

import { toast } from "react-toastify";
import {
  ADMINISTRATOR,
  DIRECTOR,
  FINTECH,
  MANAGER,
  AGENT,
} from "../../../../../utils/Roles";
import * as types from "../../../../../utils/data/dataActionTypes";
import userHasAccess from "../../../../../utils/userHasAccess";
import { ACTIVE, IMPLEMENTATION, INACTIVE } from "./enums/clientCoveragesStatusTypes";
import { getRetroactiveLimitDate } from "../../../../common/RetroactiveData/RetroactiveLimitHelper";
import { TERMINATED } from "../../enums/clientStatusTypes";
import { LIST_API_HOOK_ERRORS } from "../../../../common/enums/apiHooksErrorType";
import { MAX_DECIMAL } from "../../../../common/Configurations/DecimalConfiguration";

class ClientCoveragesDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      blockInactivationSubmission: false,
      maximumRetroactiveDate: undefined,
      fetchingMaximumRetroactiveDate: true
    };
    this.archiveClientCoverage = this.archiveClientCoverage.bind(this);
    this.createClientCoverage = this.createClientCoverage.bind(this);
    this.createEmptyClientCoverageModel = this.createEmptyClientCoverageModel.bind(
      this
    );
    this.generateConfirmationMessage = this.generateConfirmationMessage.bind(
      this
    );
    this.setCellClassNames = this.setCellClassNames.bind(this);
    this.toggleArchivedClientCoverages = this.toggleArchivedClientCoverages.bind(
      this
    );
    this.updateClientCoverage = this.updateClientCoverage.bind(this);
    this.getData = this.getData.bind(this);
    this.parseProviderRate = this.parseProviderRate.bind(this);
    this.getViewOnlyForClientStatusType = this.getViewOnlyForClientStatusType.bind(this);

    this.viewOnlyClientCoveragesForImplementation = !userHasAccess(DIRECTOR);
    this.viewOnlyClientCoveragesForActive = !userHasAccess(DIRECTOR);
    this.viewOnlyClientCoveragesForTermination = !userHasAccess(FINTECH);
    this.setBlockInactivationSubmission = this.setBlockInactivationSubmission.bind(
      this
    );
    this.setmaximumRetroactiveDate = this.setmaximumRetroactiveDate.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(CLIENT_COVERAGES);
    this.setmaximumRetroactiveDate();
  }

  setmaximumRetroactiveDate() {
    getRetroactiveLimitDate(this.props.clientId, (result) => {
      this.setState({
        maximumRetroactiveDate: result,
        fetchingMaximumRetroactiveDate: false
      });
    });

  }

  setBlockInactivationSubmission(value) {
    this.setState({ blockInactivationSubmission: value });
  }

  archiveClientCoverage(clientCoverageId, isArchived) {
    this.props.dataActions
      .updateDataItem(CLIENT_COVERAGES, {
        clientCoverageId,
        isArchived: !isArchived,
        clientId: this.props.clientId
      })
      .then((data) => {
        if (data.type === types.UPDATE_DATA_ITEM_FAILURE && LIST_API_HOOK_ERRORS.includes(data.payload.error.data.message)) {
          toast(
            <FormattedMessage id={data.payload.error.data.message} />,
            {
              type: toast.TYPE.ERROR,
              autoClose: true,
            }
          );
        }
        else {
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.q,
            this.props.sortBy,
            this.props.filters
          );
        }
      }
      );
  }

  cleanSubmitValues(values) {
    const valuesTemplate = this.getExpectedValuesTemplate(
      values.guaranteeType || values.guarantee.guaranteeType
    );
    let newValues = {};

    valuesTemplate.map((field) => {
      const value = values[field];
      switch (field) {
        case "billingPeriodId": {
          newValues[field] = value == "null" ? null : Number(value);
          break;
        }
        case "formulaPart1":
        case "formulaPart2":
        case "formulaPart3":
        case "formulaMultiple1":
        case "formulaMultiple2":
        case "formulaMultiple3": {
          newValues[field] = value == "" ? null : value;
          break;
        }
        default: {
          newValues[field] = values[field] === 0 ? "0" : values[field];
        }
      }
    });

    return newValues;
  }

  createClientCoverage(values) {
    let newValues = this.cleanSubmitValues({ ...values });
    return this.props.dataActions
      .createDataItem(CLIENT_COVERAGES, newValues)
      .then((data) => {
        if (data.type === types.CREATE_DATA_ITEM_FAILURE && LIST_API_HOOK_ERRORS.includes(data.payload.error.data.message)) {
          toast(
            <FormattedMessage id={data.payload.error.data.message} />,
            {
              type: toast.TYPE.ERROR,
              autoClose: true,
            }
          );
        } else {
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.q,
            this.props.sortBy,
            this.props.filters
          );
        }
      });
  }

  createEmptyClientCoverageModel(clientId, clientInsuranceStatusType) {
    const localizations = {};
    [...this.props.languages]
      .sort((a, b) => a.languageCode.localeCompare(b.languageCode))
      .map((l) => {
        localizations[l.languageCode] = {
          administrator: "",
          languageCode: l.languageCode,
        };
      });

    return {
      clientId,
      clientInsuranceStatusType,
      localizations,
      prices: [],
      formulaType: "FIXED",
      markUpRate: "100",
      clientReserveRate: "0",
    };
  }

  getExpectedValuesTemplate(type) {
    const types = {
      common: [
        "billingPeriodId",
        "description",
        "clientCoverageId",
        "ageOfPolicyDecrease",
        "ageOfPolicyExpiration",
        "clientId",
        "commissionRate",
        "guaranteeId",
        "insurerId",
        "localizations",
        "percentageOfPolicyDecrease",
        "policyNumber",
        "taxType",
        "suitableForInternationalMembers",
        "markUpRate",
        "clientReserveRate",
      ],

      FIXED: ["invoicedClientRate", "clientRate", "providerRate"],

      FORMULA: [
        "formulaType",
        "invoicedClientRate",
        "clientRate",
        "providerRate",

        "formulaVolume",

        "formulaSalaryDenominator",
        "formulaPart1",
        "formulaMultiple1",
        "formulaPart2",
        "formulaMultiple2",
        "formulaPart3",
        "formulaMultiple3",
        "formulaRoundedNumber",
        "formulaMspa",
        "formulaMaximum",
      ],

      MEMBER: [],
      MEMBER_MULTIPLIER: [],

      PRICE_LIST: [
        "defaultInvoicedClientRateCouple",
        "defaultInvoicedClientRateFamily",
        "defaultInvoicedClientRateSingle",
        "defaultInvoicedClientRateSingleParent",
        "defaultInvoicedClientRateWaived",

        "defaultClientRateCouple",
        "defaultClientRateFamily",
        "defaultClientRateSingle",
        "defaultClientRateSingleParent",
        "defaultClientRateWaived",

        "defaultProviderRateCouple",
        "defaultProviderRateFamily",
        "defaultProviderRateSingle",
        "defaultProviderRateSingleParent",
        "defaultProviderRateWaived",

        "defaultTpaFeeCouple",
        "defaultTpaFeeFamily",
        "defaultTpaFeeSingle",
        "defaultTpaFeeSingleParent",
        "defaultTpaFeeWaived",

        "defaultGapFeeCouple",
        "defaultGapFeeFamily",
        "defaultGapFeeSingle",
        "defaultGapFeeSingleParent",
        "defaultGapFeeWaived",

        "prices",
        "tpaTaxType",
      ],
    };

    return [...types.common, ...types[type]];
  }

  setCellClassNames(clientCoverage) {
    return classNames({
      archived: clientCoverage.isArchived,
    });
  }

  toggleArchivedClientCoverages() {
    const isArchivedFiltered = this.props.filters.includes(
      CLIENT_COVERAGES.archiveFilter
    );
    const filters = isArchivedFiltered
      ? this.props.filters.filter(
        (filter) => filter != CLIENT_COVERAGES.archiveFilter
      )
      : [...this.props.filters, CLIENT_COVERAGES.archiveFilter];
    this.getData(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters
    );
  }

  updateClientCoverage(values) {
    let newValues = this.cleanSubmitValues(values);
    this.props.dataActions
      .updateDataItem(CLIENT_COVERAGES, newValues)
      .then((data) => {
        if (data.type === types.UPDATE_DATA_ITEM_FAILURE && LIST_API_HOOK_ERRORS.includes(data.payload.error.data.message)) {
          toast(
            <FormattedMessage id={data.payload.error.data.message} />,
            {
              type: toast.TYPE.ERROR,
              autoClose: true,
            }
          );
        }
        else {
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.q,
            this.props.sortBy,
            this.props.filters
          );
        }
      });
  }

  getCols() {
    const { authLanguageCode } = this.props;
    return [
      {
        name: <FormattedMessage id="clientCoverages.datatable.columns.name" />,
        key: "guarantee.localizations.name",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            <span className="client-coverage-name">{clientCoverage.guarantee.localizations[authLanguageCode].name}</span>
            <span className="client-coverage-details">{clientCoverage.description}</span>
          </span>
        ),
        widthPct: 18,
      },
      {
        name: (
          <FormattedMessage id="clientCoverages.datatable.columns.insurerName" />
        ),
        key: "insurer.localizations.name",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            <span className="client-coverage-name">{clientCoverage.insurer.localizations[authLanguageCode].name}</span>
            <span className="client-coverage-details">{clientCoverage.policyNumber}</span>
          </span>
        ),
        widthPct: 12,
      },
      {
        name: (
          <FormattedMessage id="clientCoverages.datatable.columns.startDate" />
        ),
        key: "startDate",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            {clientCoverage.startDate}
          </span>
        ),
        widthPct: 10,
      },
      {
        name: (
          <FormattedMessage id="clientCoverages.datatable.columns.commissionRate" />
        ),
        key: "commissionRate",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            {clientCoverage.commissionRate} %
          </span>
        ),
        widthPct: 8,
      },
      {
        name: <FormattedMessage id="clientCoverages.datatable.columns.type" />,
        key: "guarantee.guaranteeType",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            {
              <FormattedMessage
                id={
                  guaranteeTypes.find(
                    (type) =>
                      type.value == clientCoverage.guarantee.guaranteeType
                  ).key
                }
              />
            }
          </span>
        ),
        widthPct: 8,
      },
      {
        name: (
          <FormattedMessage id="clientCoverages.datatable.columns.ageOfPolicyExpiration" />
        ),
        key: "ageOfPolicyExpiration",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            {clientCoverage.ageOfPolicyExpiration}
          </span>
        ),
        widthPct: 8,
      },
      {
        name: (
          <FormattedMessage id="clientCoverages.datatable.columns.ageOfPolicyDecrease" />
        ),
        key: "ageOfPolicyDecrease",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            {clientCoverage.ageOfPolicyDecrease}
          </span>
        ),
        widthPct: 8,
      },
      {
        name: (
          <FormattedMessage id="clientCoverages.datatable.columns.applicableTaxes" />
        ),
        key: "taxType",
        display: (clientCoverage) => (
          <span className={this.setCellClassNames(clientCoverage)}>
            <FormattedMessage
              id={
                clientCoverageTaxTypes.find(
                  (taxType) => taxType.value == clientCoverage.taxType
                ).key
              }
            />
          </span>
        ),
        widthPct: 10,
      },
      {
        name: <FormattedMessage id="datatable.actions" />,
        display: (clientCoverage) =>
          this.generateActionButtons({
            ...clientCoverage,
            clientInsuranceStatusType: this.props.clientInsuranceStatusType,
          }),
        widthPct: 20,
      },
    ];
  }

  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }

  generateActionButtons(clientCoverage) {
    const { clientLastActiveDate, clientStatus } = this.props;
    const fields =
      "clientCoverageId,clientId,commissionRate,description,guarantee,guaranteeId,insurerId,localizations,policyNumber,startDate," +
      "ageOfPolicyExpiration,ageOfPolicyDecrease,percentageOfPolicyDecrease,taxType,tpaTaxType," +
      "suitableForInternationalMembers,invoicedClientRate,clientRate,providerRate,formulaType,formulaVolume,formulaSalaryDenominator,markUpRate,clientReserveRate," +
      "formulaRoundedNumber,formulaMspa,formulaMaximum,formulaPart1,formulaMultiple1,formulaPart2,formulaMultiple2," +
      "formulaPart3,formulaMultiple3,isArchived,prices(*)," +
      "defaultProviderRateSingle,defaultInvoicedClientRateSingle,defaultClientRateSingle,defaultTpaFeeSingle,defaultGapFeeSingle," +
      "defaultProviderRateCouple,defaultInvoicedClientRateCouple,defaultClientRateCouple,defaultTpaFeeCouple,defaultGapFeeCouple," +
      "defaultProviderRateSingleParent,defaultInvoicedClientRateSingleParent,defaultClientRateSingleParent,defaultTpaFeeSingleParent,defaultGapFeeSingleParent," +
      "defaultProviderRateFamily,defaultInvoicedClientRateFamily,defaultClientRateFamily,defaultTpaFeeFamily,defaultGapFeeFamily," +
      "defaultProviderRateWaived,defaultInvoicedClientRateWaived,defaultClientRateWaived,defaultTpaFeeWaived,defaultGapFeeWaived,";

    const viewOnly = this.getViewOnlyForClientStatusType() || this.props.isArchived;

    let data =
      !!this.props.active &&
        this.props.active.clientCoverageId === clientCoverage.clientCoverageId
        ? {
          ...this.props.active,
          guaranteeType: clientCoverage.guarantee.guaranteeType,
          clientInsuranceStatusType: this.props.clientInsuranceStatusType,
        }
        : null;
    if (data !== null) {
      data = this.parseProviderRate(data);
    }
    return (
      <ButtonToolbar key={clientCoverage.clientCoverageId}>
        {userHasAccess([ADMINISTRATOR, MANAGER, FINTECH, AGENT]) && (
          <EditButton
            modalClassName="extra-large-modal modal-client-coverages"
            title={<FormattedMessage id={`clientCoverages.datatable.actions.${viewOnly ? "view" : "edit"}`} />}
            label={<FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />}
            allowSubmission={!viewOnly}
            form={BasicClientCoveragesFields}
            blockSubmission={this.state.blockInactivationSubmission}
            data={data}
            props={{
              clientLastActiveDate,
              clientStatus,
              clientCoverageBillingPeriodId: clientCoverage.billingPeriodId,
              setBlockInactivationSubmission: this
                .setBlockInactivationSubmission,
              active: this.props.active,
              maximumRetroactiveDate: this.state.maximumRetroactiveDate,
              clientBillingPeriodType: this.props.clientBillingPeriodType,
              fetchingMaximumRetroactiveDate: this.state.fetchingMaximumRetroactiveDate
            }}
            getData={this.props.dataActions.getDataItem.bind(
              this,
              CLIENT_COVERAGES,
              clientCoverage.clientCoverageId,
              { fields },
              {
                "Accept-Language": this.props.languages.map(
                  (l) => l.languageCode
                ),
              }
            )}
            editFunction={this.updateClientCoverage}
            requiresConfirmation={true}
            confirmationMessage={
              <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
            }
            confirmationTitle={
              <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                {this.renderFormatedMessage}
              </FormattedMessage>
            }
            requiresCloseConfirmation={true}
            confirmOnClose={true}
            confirmationValidMessage={this.generateConfirmationMessage.bind(
              this,
              false
            )}
          />
        )}
      </ButtonToolbar>
    );
  }

  generateAddButton(clientId, clientInsuranceStatusType) {
    const { clientLastActiveDate, clientStatus } = this.props;
    const viewOnly = this.getViewOnlyForClientStatusType();

    return (
      <div>
        <CheckboxButton
          className="include-archived"
          id="archived"
          label={
            <FormattedMessage id="clientCoverages.datatable.actions.includeArchivedClientCoverages" />
          }
          checked={!this.props.filters.includes(CLIENT_COVERAGES.archiveFilter)}
          onClick={this.toggleArchivedClientCoverages}
        />
        {!viewOnly && (
        <EditButton
          modalClassName="extra-large-modal"
          title={
            <FormattedMessage id="clientCoverages.datatable.actions.add" />
          }
          label={<FormattedMessage id="common.add" />}
          disabled={this.props.isArchived}
          add={true}
          form={BasicClientCoveragesFields}
          blockSubmission={this.state.blockInactivationSubmission}
          data={this.createEmptyClientCoverageModel(
            clientId,
            clientInsuranceStatusType
          )}
          props={{
            clientLastActiveDate,
            clientStatus,
            setBlockInactivationSubmission: this.setBlockInactivationSubmission,
            maximumRetroactiveDate: this.state.maximumRetroactiveDate,
            clientBillingPeriodType: this.props.clientBillingPeriodType,
            fetchingMaximumRetroactiveDate: this.state.fetchingMaximumRetroactiveDate
          }}
          editFunction={this.createClientCoverage}
          requiresConfirmation={true}
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          confirmationValidMessage={this.generateConfirmationMessage.bind(
            this,
            false
          )}
        />          
      )}
      </div>
    );
  }

  generateConfirmationMessage(edit = false, values) {
    const { formatDate, formatMessage } = this.context.intl;
    const {
      guaranteeName,
      insurerName,
      formulaDenominator,
      startDate,
      commissionRate,
    } = values;
    const cleanedValues = {
      ...this.cleanSubmitValues({ ...values }),
      formulaDenominator,
      startDate,
    };

    let { guaranteeType } = values;
    if (guaranteeType === "FORMULA") {
      guaranteeType += `_${cleanedValues.formulaType}`;
    }

    const dateFormat = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      timeZone: "UTC",
    };
    const messagePath =
      "clientCoverages.datatable.actions.confirmationMessages.";
    const messageFormatKey = `${messagePath}${guaranteeType}`;

    const isDate = !!cleanedValues.startDate;

    const formattedDateMessage = isDate
      ? formatDate(cleanedValues.startDate, dateFormat)
      : formatMessage({
        id: "clientClasses.form.fiscalSplit.nextBillingPeriod",
      });

    return (
      <div>
        {edit && (
          <FormattedHTMLMessage id={`${messagePath}editWarning`}>
            {(m) => <div dangerouslySetInnerHTML={{ __html: m }} />}
          </FormattedHTMLMessage>
        )}
        <FormattedHTMLMessage
          id={`${messagePath}genericReview`}
          values={{
            startDate: formattedDateMessage,
            guaranteeName,
            insurerName,
            commissionRate,
          }}
        >
          {(m) => (
            <div
              className="formatted-confirmation"
              dangerouslySetInnerHTML={{ __html: m }}
            />
          )}
        </FormattedHTMLMessage>
        {guaranteeType !== "PRICE_LIST" && (
          <FormattedHTMLMessage id={messageFormatKey} values={cleanedValues}>
            {(m) => (
              <div
                className="formatted-confirmation"
                dangerouslySetInnerHTML={{ __html: m }}
              />
            )}
          </FormattedHTMLMessage>
        )}
        {guaranteeType === "PRICE_LIST" && (
          <div>
            <FormattedHTMLMessage
              id={messageFormatKey + "_DEFAULTS"}
              values={cleanedValues}
            >
              {(m) => (
                <div
                  className="formatted-confirmation six-columns"
                  dangerouslySetInnerHTML={{ __html: m }}
                />
              )}
            </FormattedHTMLMessage>
            {cleanedValues.prices.map((price) => {
              const className = price.className || price.classes.name;
              const pricesFixedZeroes = { ...price };
              Object.keys(pricesFixedZeroes).forEach((key) => {
                if (pricesFixedZeroes[key] === 0) {
                  pricesFixedZeroes[key] = "0";
                }
              });
              const values = { ...pricesFixedZeroes, className };
              return (
                <FormattedHTMLMessage
                  key={`${price.classId}${price.coverageType}`}
                  id={messageFormatKey + "_LINES"}
                  values={values}
                >
                  {(m) => (
                    <div
                      className="formatted-confirmation six-columns"
                      dangerouslySetInnerHTML={{ __html: m }}
                    />
                  )}
                </FormattedHTMLMessage>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  getData(offset, limit, q, sortBy, filters) {
    const fields =
      "clientCoverageId," +
      "startDate," +
      "clientId," +
      "commissionRate," +
      "description," +
      "guarantee," +
      "guaranteeId," +
      "insurerId," +
      "insurer(*)," +
      "localizations," +
      "policyNumber," +
      "ageOfPolicyExpiration," +
      "ageOfPolicyDecrease," +
      "percentageOfPolicyDecrease," +
      "taxType," +
      "suitableForInternationalMembers," +
      "invoicedClientRate," +
      "markUpRate" +
      "clientReserveRate" +
      "clientRate," +
      "providerRate," +
      "formulaType," +
      "formulaVolume," +
      "formulaSalaryDenominator," +
      "formulaRoundedNumber," +
      "formulaMaximum," +
      "formulaPart1," +
      "formulaMultiple1," +
      "formulaPart2," +
      "formulaMultiple2," +
      "formulaPart3," +
      "formulaMultiple3," +
      "defaultProviderRateSingle," +
      "defaultInvoicedClientRateSingle," +
      "defaultClientRateSingle," +
      "defaultProviderRateCouple," +
      "defaultInvoicedClientRateCouple," +
      "defaultClientRateCouple," +
      "defaultProviderRateSingleParent," +
      "defaultInvoicedClientRateSingleParent," +
      "defaultClientRateSingleParent," +
      "defaultProviderRateFamily," +
      "defaultInvoicedClientRateFamily," +
      "defaultClientRateFamily," +
      "defaultProviderRateWaived," +
      "defaultInvoicedClientRateWaived," +
      "defaultClientRateWaived," +
      "isArchived," +
      "prices(*)";
    return this.props.dataActions.getDataList(
      CLIENT_COVERAGES,
      offset,
      limit,
      q,
      sortBy,
      filters,
      {},
      { clientId: this.props.clientId },
      fields
    );
  }

  parseProviderRate(data) {
    const { commissionRate = 0 } = data;
    const rate = (clientRate = 0) =>
      (clientRate - clientRate * (commissionRate / 100)).toFixed(MAX_DECIMAL);

    return {
      ...data,
      providerRate: rate(data.clientRate),

      defaultProviderRateCouple: rate(data.defaultClientRateCouple),
      defaultProviderRateFamily: rate(data.defaultClientRateFamily),
      defaultProviderRateSingle: rate(data.defaultClientRateSingle),
      defaultProviderRateSingleParent: rate(data.defaultClientRateSingleParent),
      defaultProviderRateWaived: rate(data.defaultClientRateWaived),

      prices: data.prices.map((price) => ({
        ...price,
        providerRate: rate(price.clientRate),
      })),
    };
  }

  getViewOnlyForClientStatusType() {
    const { client } = this.props;

    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return this.viewOnlyClientCoveragesForImplementation;
      case ACTIVE.value:
      case INACTIVE.value:
        return this.viewOnlyClientCoveragesForActive;
      case TERMINATED.value:
        return this.viewOnlyClientCoveragesForTermination;
    }
  }

  render() {
    return (
      <DataTable
        ref="dataTable"
        title={<FormattedMessage id="clientCoverages.title" />}
        getData={this.getData}
        cols={this.getCols()}
        q={this.props.q}
        filters={this.props.filters}
        offset={this.props.offset}
        data={this.props.items}
        rowsPerPage={this.props.limit}
        totalRows={this.props.total}
        sortBy={this.props.sortBy}
        addButton={this.generateAddButton(
          this.props.clientId,
          this.props.clientInsuranceStatusType
        )}
      />
    );
  }
}

ClientCoveragesDataTable.propTypes = {
  active: PropTypes.object,
  authLanguageCode: PropTypes.string,
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  q: PropTypes.string,
  items: PropTypes.array,
  languages: PropTypes.array.isRequired,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  clientId: PropTypes.number,
  clientInsuranceStatusType: PropTypes.string,
  statuses: PropTypes.array,
  insuranceTypes: PropTypes.array,
  client: PropTypes.object,
  isArchived: PropTypes.bool,
  clientLastActiveDate: PropTypes.string,
  clientStatus: PropTypes.string,
  clientBillingPeriodType: PropTypes.string
};

ClientCoveragesDataTable.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  const data = state.data.clientCoverages || {};
  const newClient = data.clientId != state.data.clients.active.clientId;
  const pagination = data.pagination || {};
  const client = state.data.clients.active;
  return {
    active: data.active,
    q: data.q,
    authLanguageCode: state.auth.user.languageCode,
    clientStatus: client.clientStatusType,
    clientLastActiveDate: client.lastActiveDate,
    clientBillingPeriodType: client.clientBillingPeriodType,
    filters: newClient
      ? [
        `clientId==${state.data.clients.active.clientId}`,
        CLIENT_COVERAGES.archiveFilter,
      ]
      : data.filters,
    clientId: client.clientId,
    clientInsuranceStatusType: client.clientInsuranceStatusType,
    limit: pagination.limit || 100,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["guaranteeId:asc"],
    total: pagination.totalCount || 0,
    items: data.items || null,
    client: state.data.clients.active,
    isArchived: client.isArchived,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientCoveragesDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/ClientCoveragesDataTable.js